import { Rule } from 'antd/lib/form';

export const contactFormRules = {
    name: (): Rule[] => [{ required: true, max: 127 }],
    email: (): Rule[] => [{ required: true, max: 127, type: 'email' }],
    message: (): Rule[] => [{ required: true, max: 4095 }],
}